var map = {
	"./water01.png": "3dd5",
	"./water01_selected.png": "02ff",
	"./water01_short.png": "2ff7",
	"./water02.png": "f01c",
	"./water02_selected.png": "2de7",
	"./water03.png": "1dc2",
	"./water03_selected.png": "3b82",
	"./water04.png": "4576",
	"./water04_selected.png": "24c3",
	"./water05.png": "2c60",
	"./water05_selected.png": "4b73",
	"./water06.png": "87d0",
	"./water06_selected.png": "fc61"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1a78";